export const findOffsetRelativeToGrandparent = (
  element: any,
  className: string
) => {
  let currentElement = element;
  let top = 0;
  let left = 0;

  while (currentElement && !currentElement.classList.contains(className)) {
    top += currentElement.offsetTop;
    left += currentElement.offsetLeft;
    currentElement = currentElement.offsetParent;
  }

  return { top, left };
};

export function isElementVisible(element: HTMLElement | null): boolean {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0' &&
    element.offsetParent !== null
  );
}
